module.exports = function (data) {
    const event = {
        event: 'BWSAUaddToFavourites',
        eventContext: {
            area: data.area,
            unitprice: data.product.SalePrice || data.product.Price,
            unitDisplay: data.product.Unit,
            productInfo: data.product.ProductData,
            isOnSpecial: data.product.IsSpecial ? 'true' : 'false',
            eventID: data.headers('x-eventid')
        }
    };

    if (data.eventData) {
        Object.assign(event.eventContext, {
            eventCampaignName: data.eventData.campaignName,
            eventPlace: data.eventData.place,
            eventPosition: data.eventData.position,
            eventType: data.eventData.type
        });
    }

    return event;
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/cards/detail/product/atm-mapper-add-to-favorite.js
 **/